import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { RootState } from "app/store";
import { setShowGlobalAlert } from 'app/store/slices/authSlice';
import { Routes } from 'app/shared/constants/constants';
import logging from 'app/shared/utils/logging';
import { GlobalAlertConfig } from 'app/services/api/commonTypes';
import { isValidGlobalAlertConfig } from 'app/shared/utils/helperFunctions';
import { createDefaultMetricData, useTrackPageViewAndMetrics} from 'app/shared/utils/AppInsightsUtility';
import { getEventNamespace } from 'app/shared/utils/AzureNamespace';
import NavbarComp from "./Navigation";
import GlobalAlert from './GlobalAlert';

const AppHeader: React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { configs, showGlobalAlert } = useSelector((state: RootState) => state.auth);
    const [alertConfig, setAlertConfig] = useState<GlobalAlertConfig | undefined>();
    const additionalProperties = { "Component Name": "AppHeader" };
    const appInsights = useTrackPageViewAndMetrics("AppHeader", createDefaultMetricData(), additionalProperties);

    useEffect(() => {
        try {
            const rawAlertConfig = configs?.brandConfigs?.GLOBAL_APP_ALERT;
            if (rawAlertConfig) {
                const parsed = JSON.parse(rawAlertConfig) as GlobalAlertConfig;
                if (isValidGlobalAlertConfig(parsed)) {
                    setAlertConfig(parsed);
                } else {
                    logging.error(appInsights, getEventNamespace("APP_HEADER", 'GLOBAL_APP_ALERT_ERROR'), "Invalid GLOBAL_APP_ALERT JSON, missing required fields");
                }
            } else {
                setAlertConfig(undefined);
            }
        } catch (error) {
            logging.error(appInsights, getEventNamespace("APP_HEADER", 'GLOBAL_APP_ALERT_ERROR'), "Invalid GLOBAL_APP_ALERT JSON, unable to parse", error);
        }
    }, [configs, appInsights]);

    const isEnabled = alertConfig?.enabled === 'true';
    const hasContent = !!(alertConfig?.header || alertConfig?.message);
    const shouldShowAlert = showGlobalAlert && isEnabled && hasContent;

    const closeGlobalAlert = (() => {
        dispatch(setShowGlobalAlert(false));
    });

    // Hide App Header in embed mobile giftcard transfer
    if (location.pathname === Routes.MOBILE_GIFTCARD_TRANSFER_ROUTE) {
        return null;
    }

    return (
        <div className="appHeader">
            {alertConfig && (
                <GlobalAlert
                    show={shouldShowAlert}
                    onClose={closeGlobalAlert}
                    globalAlert={alertConfig}
                />
            )}
            <NavbarComp />
        </div>
    );
};

export default AppHeader;
